module.exports = __webpack_public_path__ + "static/media/logs.0f22c1d5.svg";